import React from 'react';
import '../../loader/loader.scss';

type Props = Readonly<{
  fromLinksModal?: boolean;
}>;

export default function TableSkeleton({ fromLinksModal }: Props) {
  const skeletonItems = ['a', 'b', 'c', 'd', 'e', 'f'];
  const visibleItems = fromLinksModal ? skeletonItems.slice(0, 4) : skeletonItems;
  return (
    <div
      className='interactiveSkeleton'
      style={{ gap: fromLinksModal ? '15px' : '20px' }}
      data-testid='table-skeleton'
    >
      {visibleItems.map((id) => (
        <div key={id} className='col'>
          <div
            className='text-center skeletonForInteractive'
            style={{ height: fromLinksModal ? '30px' : '50px' }}
          />
        </div>
      ))}
    </div>
  );
}
